import React from "react";
import randomElement from './randomElement';
import positive from './positive';
import negative from './negative';

function message({form, isCompleted, minigameType, comm}, mode){
    let globComm = comm ? <p>{comm}</p> : false;
    let result = {};
    if(noMsgModes.indexOf(minigameType) !== -1){
        return {};
    }
    let head;
    let tail = [];

    result.onFinish = (playerAns) => {
        let comm = false;
        let correctAns = form.correct;
        /* let right = "Вы выбрали правильный ответ "; */
        let wrong = "Вы выбрали неправильный ответ ";
        let nf = "Вы не выбрали правильный ответ ";

        if(isCompleted(form, playerAns)){
            head = <p align='center'>{randomElement(positive)}</p>;
        }
        else {
            head = <p align='center'>{randomElement(negative)}</p>;
        }

        if(mode === 1){
            return <div>{head}</div>; 
        }

        let isEmptyComm = form.comms.some(elem => elem !== null);
        
        if(!Array.isArray(playerAns)){
            playerAns = [playerAns];
            correctAns = [correctAns];
        }

/*         let rightAns = playerAns.filter(elem => correctAns.indexOf(elem) !== -1); */
        let missedAns = correctAns.filter(elem => playerAns.indexOf(elem) === -1);
        let wrongAns = playerAns.filter(elem => correctAns.indexOf(elem) === -1);

        
        if(form.type === "ManyAnsQuestion"){
            comm = <p align='center'>Выбрано вариантов: {playerAns.length} (правильно: 
                <span className="good"> {correctAns.length - missedAns.length}</span>/{correctAns.length}
                {wrongAns.length !== 0 ? <>, неправильно: <span className="bad">{wrongAns.length}</span></> : false}).</p>;
        }

        /* for(let i = 0; i < rightAns.length; i++){
            tail.push(<li className="commentary" key={i}>{right + "«" + form.options[rightAns[i]] + "»."}</li>);
            if(form.comms[rightAns[i]] !== null) tail.push(<p className="commentary" key={i}>{form.comms[rightAns[i]]}</p>);
        } */
        for(let i = 0; i < wrongAns.length; i++) {
            tail.push(<li className="commentary" key={"wrong" + i}>{wrong + "«" + form.options[wrongAns[i]] + "»."}</li>);
            if(form.comms[wrongAns[i]] !== null) tail.push(<p className="commentary" key={"wrong" + i + 100}>{form.comms[wrongAns[i]]}</p>);
        }
        for(let i = 0; i < missedAns.length; i++){
            tail.push(<li className="commentary" key={"missed" + i}>{nf + "«" + form.options[missedAns[i]] + "»."}</li>);
            if(form.comms[missedAns[i]] !== null) tail.push(<p className="commentary" key={"missed" + i + 100}>{form.comms[missedAns[i]]}</p>);
        }
        if(tail.length !== 0){
            tail = <ol>{tail}</ol>;
        }
        else{
            tail = false;
        }
        if(isEmptyComm) {
            return <div>{head}{comm}{tail}</div>; 
        }
        return <div>{head}{comm}{tail}{globComm}</div>; 
        
    }
    return result;

}

const noMsgModes = ["Greeting", "Intro", "AutoFinish", "Final"];


function multiple(form, isCompleted, goodText, badText){
    let goodRes, badRes;
    const { comms } = form;

    if(goodText !== ""){
        goodRes = <div><p align='center'>{randomElement(positive)}</p>{goodText}</div>;
    }
    else {
        goodRes = <div><p align='center'>{randomElement(positive)}</p></div>;
    }
    if(badRes !== ""){
        badRes = <div><p align='center'>{randomElement(negative)}</p>{badText}</div>;
    }
    else{
        badRes = <div><p align='center'>{randomElement(negative)}</p></div>;
    }

    return (move) => {
        if(!(comms) || comms.length === 0 || !(comms[move])){
            return isCompleted(form, move) ? goodRes : badRes;
        }
        else {
            var comm = comms[move]; 
            return isCompleted(form, move) ? <div><p align='center'>{randomElement(positive)}</p>{comm}</div> : <div><p align='center'>{randomElement(negative)}</p>{comm}</div>;
        }
    };
    
}

export default message;
